import StatisticsAPIs from '@/API/marketing/statistics-api'
import CampaignsChannelsApi from '@/API/super-admin/campaigns-channels-api'

export default {
  namespaced: true,
  state: {
    tiersFetched: false,
    tiers: [],
    channels: [],
    channelsFetched: false,
  },
  getters: {
    tiers: (state: any) => state.tiers,
    channels: (state: any) => state.channels,
  },
  mutations: {
    SET_TIERS(state: any, tiers: any) {
      state.tiers = tiers
      state.tiersFetched = true
    },
    SET_CHANNELS(state: any, channels: any) {
      state.channels = channels
      state.channelsFetched = true
    },
  },
  actions: {
    async FETCH_TIERS(context: any) {
      if (context.state.tiersFetched) return
      // eslint-disable-next-line consistent-return,no-return-await
      try {
        const res = await StatisticsAPIs.customerPageStatistics()
        const modifiedOthers = res?.other?.map((obj: any) => ({
          ...obj,
          id: obj.filter_query,
        })) ?? []
        const tiers = res.tiers.map((obj: any) => ({
          ...obj,
          id: obj.filter_query,
        })) ?? []
        const mergedArray = [
          ...tiers,
          ...modifiedOthers,
        ]
        context.commit('SET_TIERS', mergedArray)
      } catch (error) {
        // Handle error, e.g., show a notification or log the error
        console.error('Error fetching tiers:', error)
      }
    },
    async FETCH_CHANNELS(context: any) {
      if (context.state.channelsFetched) return
      // eslint-disable-next-line consistent-return,no-return-await
      try {
        const res = await CampaignsChannelsApi.list()
        const channels = res ?? []
        context.commit('SET_CHANNELS', channels)
      } catch (error) {
        console.error('Error fetching channels:', error)
      }
    },
  },

}
